import PropTypes from "prop-types";
import React from "react";
import Tab from "react-bootstrap/Tab";
import instagramPosts from "../../data/instagram-posts/instagram-posts.json";
import { Link } from "react-router-dom";

const TabProduct = ({
                      spaceTopClass,
                      spaceBottomClass,
                      bgColorClass,
                      category,
                    }) => {
  const renderInstagramPost = () => {
    return instagramPosts.map((instaPost) => {
      return (
        <a href={instaPost.link} target="_blank">
          <div
            className="product-img-background"
            style={{
              backgroundImage: `url(${
                process.env.PUBLIC_URL + instaPost &&
                instaPost.images &&
                instaPost.images
              })
                        `,
              height: "20rem",
              backgroundRepeat: "no-repeat",
              width: "20rem",
              backgroundSize: "cover",
              cursor: "pointer",
            }}
          />
        </a>
      );
    });
  };

  return (
    <div
      className={`product-area ${spaceTopClass ? spaceTopClass : ""} ${
        spaceBottomClass ? spaceBottomClass : ""
      } ${bgColorClass ? bgColorClass : ""}`}
    >
      <div className="container">
        <div className={`section-title text-center `}>
          <h2>Siguenos en instagram</h2>
        </div>
        <Tab.Container defaultActiveKey="">
          <Tab.Content>
            <Tab.Pane eventKey="">
              <div className="row pt-70 mo xs-justify-content-center mobile-instagram" style={{ justifyContent: 'space-evenly'}}>
                {renderInstagramPost()}
              </div>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </div>
  );
};

TabProduct.propTypes = {
  bgColorClass: PropTypes.string,
  category: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string,
};

export default TabProduct;
